// Simple Brand Search - Filters existing brand items on the page
document.addEventListener('DOMContentLoaded', function() {
  const searchInput = document.querySelector('.brand-search-bar input');
  const brandItems = document.querySelectorAll('.brand-category-item');
  const brandSections = document.querySelectorAll('.brand-category-section');
  
  if (!searchInput || brandItems.length === 0) return;
  
  searchInput.addEventListener('input', function() {
    const query = this.value.toLowerCase().trim();
    
    if (query === '') {
      // Show all brands
      brandItems.forEach(item => {
        item.style.display = '';
      });
      brandSections.forEach(section => {
        section.style.display = '';
      });
      return;
    }
    
    let hasVisibleItems = false;
    
    // Filter brand items
    brandItems.forEach(item => {
      const link = item.getAttribute('href') || '';
      const brandName = extractBrandName(link);
      
      if (brandName.includes(query)) {
        item.style.display = '';
        hasVisibleItems = true;
      } else {
        item.style.display = 'none';
      }
    });
    
    // Hide/show sections based on visible items
    brandSections.forEach(section => {
      const sectionItems = section.querySelectorAll('.brand-category-item');
      const hasVisible = Array.from(sectionItems).some(item => 
        item.style.display !== 'none'
      );
      
      if (hasVisible) {
        section.style.display = '';
      } else {
        section.style.display = 'none';
      }
    });
  });
  
  function extractBrandName(link) {
    // Extract brand name from collection URL like /collections/brand-name
    const matches = link.match(/\/collections\/([^\/\?]+)/);
    if (matches && matches[1]) {
      return matches[1].replace(/-/g, ' ').toLowerCase();
    }
    return '';
  }
});